import React from 'react'

export default function ShowErrors({ errors }) {
  return (
    <>
        {errors.length > 0 ?
            <div className="mb-4 text-red-300 text-sm">
                Errors:
                <ul className='list-disc pl-[revert]'>
                    {errors.map((error, index) => (
                        <li key={index}>
                            {error}
                        </li>
                    ))}
                </ul>
            </div>
        : ''}
    </>
  )
}
